import { MediumModel } from './types';
import { GenericState, IState } from '../../../common/store/types';
import { onApiCall } from '../../../common/store/generic.reducer';
import { mediumActions } from './medium.action';
import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { ListItem } from '../typeahead/types';

export interface IMediumState extends IState<MediumModel> {
  getById: GenericState<MediumModel>;
  getList: GenericState<ListItem[]>;
  add: GenericState<MediumModel>;
  update: GenericState<MediumModel>;
}

export const mediumInitialState: IMediumState = {
  getById: new GenericState<MediumModel>(),
  getList: new GenericState<ListItem[]>(),
  add: new GenericState<MediumModel>(),
  update: new GenericState<MediumModel>(),
};

const mediumReducers = [
  ...onApiCall<MediumModel>(mediumActions.getById, 'getById'),
  ...onApiCall<ListItem[]>(mediumActions.getList, 'getList'),
  ...onApiCall<MediumModel>(mediumActions.add, 'add'),
  ...onApiCall<MediumModel>(mediumActions.update, 'update'),
];

export const mediumReducer = createReducer(
  mediumInitialState,
  ...mediumReducers,
) as ActionReducer<IMediumState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return mediumReducer(state, action);
}
